<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="87" height="55" viewBox="0 0 87 55" fill="none">
        <path
            d="M86 11.6197C57.4504 -15.3489 27.7918 15.4057 36.8801 33.6337C44.4733 48.8632 69.3228 28.2831 49.6641 17.3999C30.0054 6.51673 0.999998 14.4578 0.999996 54"
            stroke="url(#paint0_linear_232_1845)" stroke-width="1.5" stroke-linecap="round" stroke-dasharray="3 5" />
        <defs>
            <linearGradient id="paint0_linear_232_1845" x1="43.5" y1="0.999998" x2="43.5" y2="54"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF671F" />
                <stop offset="0.785933" stop-color="#EF4029" />
                <stop offset="1" stop-color="#ED1C24" stop-opacity="0.929412" />
            </linearGradient>
        </defs>
    </svg>
</template>

<script setup lang="ts">
</script>

<style></style>
